import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OnlyNumber } from 'src/core/directives/only-number.directive';
import { MinValueDirective } from './min-value.directive';

@NgModule({
    declarations: [
        OnlyNumber,
        MinValueDirective
    ],
    imports: [
        CommonModule,
        FormsModule

    ],
    exports: [
        OnlyNumber,
        MinValueDirective
    ]
})
export class OnlyNumberModule { }
